<template>
    <router-view/>
</template>

<script>
    export default {
        name: "kategori"
    }
</script>

<style scoped>

</style>